/**
 * Core game systems.
 *
 * Placeholder for future systems (experience, combat, etc.)
 */

import type { GameSystem } from '@/registry/SystemRegistry';

/**
 * All core systems.
 *
 * Currently empty - systems will be added in later milestones.
 */
export const CORE_SYSTEMS: GameSystem[] = [];
